// extracted by mini-css-extract-plugin
export default {"card":"TriggerCard_card__sHyy9","cardContent":"TriggerCard_cardContent__0DAjg","iconWrapper":"TriggerCard_iconWrapper__xuwdt","title":"TriggerCard_title__CqZNq"};